import uniqid from 'uniqid';

export default {
    closeNotification(state) {
        state.notificationData = Object.assign(
            {},
            {
                show: false,
                message: '',
                type: ''
            }
        );
    },
    openNotification(state, payload) {
        state.notificationData = Object.assign(
            {},
            {
                show: true,
                message: payload.message,
                type: payload.type
            }
        );
    },
    openConfirm(state, payload) {
        state.confirm = Object.assign(
            {},
            {
                show: true,
                message: payload.message,
                title: payload.title,
                callback: payload.callback
            }
        );
    },
    closeConfirm(state) {
        state.confirm = Object.assign(
            {},
            {
                show: false,
                message: '',
                title: '',
                callback: null
            }
        );
    },

    openConfirmConflict(state, payload) {
        state.confirmConflict = Object.assign(
            {},
            {
                show: true,
                callback: payload.callback,
                data: payload.data
            }
        );
    },
    closeConfirmConflict(state) {
        state.confirmConflict = Object.assign(
            {},
            {
                show: false,
                callback: null,
                data: {}
            }
        );
    },

    openConfirmNotification(state, payload) {
        state.confirmNotification = Object.assign(
            {},
            {
                show: true,
                message: payload.message,
                title: payload.title
            }
        );
    },
    closeConfirmNotification(state) {
        state.confirmNotification = Object.assign(
            {},
            {
                show: false,
                message: '',
                title: ''
            }
        );
    },

    isShowMenuLeft(state, isShow) {
        state.isShowMenuLeft = isShow;
    },

    increaseLoading(state) {
        state.loading.count++;
    },
    decreaseLoading(state) {
        state.loading.count--;
    },
    updateCurrentMenu(state, menu) {
        state.currentMenu = menu;
    },
    updateCurrentPath(state, path) {
        state.currentPath = path;
    },

    updateCurrentPathName(state, path) {
        state.currentPathName = path;
    },

    updateCurrentFullPath(state, path) {
        state.currentFullPath = path;
    },

    addAlertItem(state, alert) {
        alert.id = uniqid();
        state.alertList.push(alert);
    },
    removeAlertItem(state, payload) {
        let index = state.alertList.findIndex((alert) => {
            return alert.id === payload.id;
        });

        if (index !== -1) {
            state.alertList.splice(index, 1);
        }
    },
    addDataOrder(state, data) {
        state.request = data;
    },
    increaseSelectId(state) {
        state.selectId++;
    }
};
